import React, { useEffect, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import History from "../homepage/History";
import ListPage from "../brands/ListPage";
import Brand from "../brands/Brand";
import homePageAPI from "../../api/homePageApi";
import homePagePayload from "../../config/homePayload";

const cards = [
  {
    title: "Superior Hydraulic Products",
    text: "Premium quality components and systems that meet the highest industry standards for reliability and performance.",
  },
  {
    title: "Customized Engineering Solutions",
    text: "Tailored hydraulic systems designed to meet specific operational requirements and optimize efficiency.",
  },
  {
    title: "Exceptional Service & Support",
    text: "Comprehensive technical support, maintenance services, and expert guidance throughout your project lifecycle.",
  },
  {
    title: "Sustainable & Cost-Effective Solutions",
    text: "Innovative solutions that reduce operational costs while promoting environmental sustainability and efficiency.",
  },
];

const About = () => {
  const [brands, setBrands] = useState([]);
  const CACHE_TIME = 3 * 60 * 1000;
  const applyData = (data) => {
    
    setBrands(data?.brands);
   
  };

  const fetchHomePageDetails = async () => {
    try {
      const cached = sessionStorage.getItem("homeData");
      const parsed = cached ? JSON.parse(cached) : null;
      if (parsed) applyData(parsed.data);
      if (!parsed || Date.now() - parsed.timestamp > CACHE_TIME) {
        const res = await homePageAPI.homePage(homePagePayload);
        if (res.code === 200) {
          sessionStorage.setItem(
            "homeData",
            JSON.stringify({
              data: res.data,
              timestamp: Date.now(),
            }),
          );
          if (!parsed) applyData(res.data); // only update state if no cache was shown
        }
      }
    } catch (error) {
      console.error("Home API Error:", error);
    }
  };
  useEffect(() => {
    fetchHomePageDetails();
  }, []);
  const data = {
    subtitle: "OUR MISSION",
    title: "Driving Excellence in Hydraulic Solutions",
    intro:
      "At ITH Hydraulics Pvt Ltd. our mission is to provide high-quality, reliable, and innovative hydraulic solutions that enhance the efficiency and longevity of industrial machinery. We strive to build long-term partnerships with our customers by delivering:",
    quote:
      "We are committed to continuous improvement, technical excellence, and customer satisfaction, ensuring that industries operate at peak efficiency with our trusted hydraulic systems.",
  };

  const leaderData = {
    subtitle: "MEET OUR LEADERSHIP & LEGACY",
    title: "Tribute to Our Founder",
    name: "LATE SUSHIL KUMAR SAGAR",
    years: "1948 — 2020",
    role: "Founder, ITH Hydraulics Pvt Ltd",
    image: "/assets/new-images/Leaders/Leader1.jpg",
    quote:
      '"A visionary leader whose dedication and passion laid the foundation for ITH Hydraulics. His commitment to quality and customer satisfaction continues to inspire us every day."',
    description:
      "Mr. Sushil Kumar Sagar's vision and entrepreneurial spirit transformed ITH from a small trading house into a trusted name in hydraulic solutions. His legacy lives on through our continued commitment to excellence and innovation in serving our customers.",
  };

  const currentleaderData = {
    subtitle: "MEET OUR LEADERSHIP & LEGACY",
    title: "Current Leadership Team",
    members: [
      {
        name: "Vishal Sagar",
        role: "Director",
        image: "assets/new-images/Leaders/Leader2.jpg",
        keyRoles: [
          "Leading business growth, operations, and strategic expansion",
          "Strengthening partnerships with OEMs and major industrial clients",
          "Leading customer relations and service excellence initiatives",
          "Driving brand positioning and market expansion strategies",
        ],
        expertise: [
          "20+ years of experience in the hydraulic/Automotive industry",
          "Expert in Service Marketing and process optimization",
          "Specializes in business development and operational excellence",
        ],
      },
      {
        name: "Ruchi Sagar",
        role: "Director",
        image: "assets/new-images/Leaders/Leader3.jpg",
        keyRoles: [
          "Overseeing strategic planning, finance, and corporate management",
          "Focus on customer satisfaction and quality assurance",
          "Expertise in corporate operations and process efficiency",
        ],
        expertise: [
          "Strong background in business strategy and client management",
          "Expertise in corporate operations and process efficiency",
          "Focus on customer satisfaction and quality assurance",
        ],
      },
    ],
  };

  return (
    <>
      <Breadcrump title="About Us" />

      {/* OUR MISSION */}
      <section className="ith-mission">
        <div className="container">
          {/* Header */}
          <div className="ith-mission-info d-flex flex-column justify-content-center align-items-center">
          <p className="ith-section-subtitle">{data.subtitle}</p>
          <h2 className="ith-section-title">{data.title}</h2>
          </div>

          {/* Main Box */}
          <div className="ith-mission__box">
            {/* Intro Text */}
            <p className="ith-mission__intro">{data.intro}</p>

            {/* Cards */}
            <div className="ith-mission__grid">
              {cards.map((card, i) => (
                <div className="ith-mission__card" key={i}>
                  <h4 className="ith-mission__card-title">{card.title}</h4>
                  <p className="ith-mission__card-text text-muted">
                    {card.text}
                  </p>
                </div>
              ))}
            </div>

            {/* Quote */}
            <blockquote className="ith-mission__quote">
              <p>{data.quote}</p>
            </blockquote>
          </div>
        </div>
      </section>

      {/* MEET OUR LEADER */}
      <section className="ith-founder">
        <div className="container">
          {/* Header */}
          <p className="ith-section-subtitle text-center">{leaderData.subtitle}</p>
          <h2 className="ith-section-title text-center">{leaderData.title}</h2>

          {/* Card */}
          <div className="ith-founder__card">
            {/* Avatar */}
            <div className="ith-founder__avatar-wrap">
              <img
                src={leaderData.image}
                alt={leaderData.name}
                className="ith-founder__avatar"
              />
            </div>

            {/* Content */}
            <div className="ith-founder__content">
              <h3 className="ith-founder__name">{leaderData.name}</h3>
              <p className="ith-founder__years">{leaderData.years}</p>
              <p className="ith-founder__role">{leaderData.role}</p>

              {/* Quote */}
              <blockquote className="ith-founder__quote">
                <span className="ith-founder__quote-mark">"</span>
                <p>{leaderData.quote}</p>
              </blockquote>

              {/* Description */}
              <p className="ith-founder__desc">{leaderData.description}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CURRENT LEADER */}
      <section className="ith-leadership">
        <div className="container">
          {/* Header */}
          <p className="ith-section-subtitle text-center">
            {currentleaderData.subtitle}
          </p>
          <h2 className="ith-section-title text-center">{currentleaderData.title}</h2>

          {/* Members Wrapper */}
          <div className="ith-leadership__wrapper">
            {currentleaderData.members.map((member, index) => (
              <React.Fragment key={index}>
                {/* Vertical Divider between members */}
                {/* {index > 0 && <div className="ith-leadership__divider" />} */}

                {/* Member Card */}
                <div className="ith-leadership__member">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="ith-leadership__avatar"
                  />

                  <h3 className="ith-leadership__name">{member.name}</h3>
                  <p className="ith-leadership__role">{member.role}</p>

                  {/* Key Role */}
                  <div className="ith-leadership__block">
                    <p className="ith-leadership__block-title">Key Role:</p>
                    <ul className="ith-leadership__list">
                      {member.keyRoles.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>

                  {/* Expertise */}
                  <div className="ith-leadership__block">
                    <p className="ith-leadership__block-title">Expertise:</p>
                    <ul className="ith-leadership__list">
                      {member.expertise.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* HISTORY */}
      <History />

      {/* BRAND */}
      <Brand brands={brands}/>
    </>
  );
};

export default About;
